import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ExportDocumentStatus, ExportIdentificationStatus } from './export.models';
import { EXPORT_FEATURE_KEY, ExportState } from './export.reducer';

export const getDataAccessFairsState = createFeatureSelector<ExportState>(EXPORT_FEATURE_KEY);

export const getExportLoadingStatus = createSelector(getDataAccessFairsState, (state: ExportState) => {
  if (state.generated && state.documentId) {
    return ExportDocumentStatus.READY;
  }

  if (state.failed) {
    return ExportDocumentStatus.FAILED;
  }

  return ExportDocumentStatus.LOADING;
});

export const getExportMetaStatus = createSelector(getDataAccessFairsState, (state: ExportState) => {
  if (state.identified && !state.identification_failed) {
    return ExportIdentificationStatus.IDENTIFIED;
  }

  if (state.identification_failed) {
    return ExportIdentificationStatus.FAILED;
  }

  return ExportIdentificationStatus.LOADING;
});

export const getExportMeta = createSelector(getDataAccessFairsState, (state: ExportState) => state.metadata);

export const getExportDocumentId = createSelector(getDataAccessFairsState, (state: ExportState) => state.documentId);
